module.exports = __webpack_public_path__ + "img/funding-jp-method.3324decd.png";